import { useEffect, useState } from "react";

import { GridPaginationModel } from "@mui/x-data-grid-pro";

import { useSettings } from "./use-settings";

type UsePaginationModelResult = [
  GridPaginationModel,
  (updatedModel: GridPaginationModel) => void,
];

const usePaginationModel = (): UsePaginationModelResult => {
  const settings = useSettings();
  const [paginationModel, setPaginationModel] = useState<GridPaginationModel>(
    () => ({
      page: 0,
      pageSize: settings.rowCount || 10,
    }),
  );

  useEffect(() => {
    if (settings.rowCount !== paginationModel.pageSize) {
      setPaginationModel({
        page: 0,
        pageSize: settings.rowCount || 10,
      });
    }
  }, [paginationModel.pageSize, settings.rowCount]);

  return [
    paginationModel,
    (updatedModel: GridPaginationModel) => {
      setPaginationModel(updatedModel);
      settings.handleUpdate({ ...settings, rowCount: updatedModel.pageSize });
    },
  ];
};
export default usePaginationModel;
